import { render, staticRenderFns } from "./dataPrivilegeStaff.vue?vue&type=template&id=68d57912&scoped=true"
import script from "./dataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./dataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./dataPrivilegeStaff.vue?vue&type=style&index=0&id=68d57912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d57912",
  null
  
)

export default component.exports